import { useEffect } from "react";
import { BUSINESS } from "../data/site";

export const SEO = ({ title, description }) => {
  useEffect(() => {
    document.title = title ? `${title}` : `${BUSINESS.name} | Mobile Welding Repair in Fort Worth, TX`;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    if (description) meta.setAttribute("content", description);
  }, [title, description]);
  return null;
};
